import { LineModel } from '@/lib/models/lines/types';
import { Codeshare } from '@/types';

export const getLineCodeshares = (
  line?: LineModel,
  operatingCarrierId?: string,
  primaryCarrierIds: string[] = [],
): Codeshare[] => {
  if (!line || !line.sharedCarriers) return [];

  const codeshares = line.sharedCarriers.map((shared) => {
    const isPrimary = primaryCarrierIds.includes(shared.carrierId);
    const isOperator = operatingCarrierId === shared.carrierId;

    const codeshare: Codeshare = {
      ...shared,
      isPrimary,
      isOperator,
    };
    return codeshare;
  });

  // Sort by isPrimary (so they are listed first), then sort alphabetically
  return codeshares?.sort((a, b) => {
    if (a.isPrimary !== b.isPrimary) {
      return a.isPrimary ? -1 : 1;
    }
    return a.carrierId.localeCompare(b.carrierId);
  });
};
